<div class="flex flex-col gap-8">
  <div class="flex min-h-9 gap-6 rounded-2xl bg-neutral-100 px-4 py-1">
    <a
      class="flex cursor-pointer items-center gap-2 text-neutral-300 hover:text-neutral-500"
      [routerLink]="['/members', memberProfile()?.id, 'appointments']"
    >
      <mat-icon>arrow_back</mat-icon>
      <span class="underline">{{ "appointments.action.backToProfile" | translate }}</span>
    </a>
    @if (memberProfile()) {
      <div class="flex gap-2 text-lg">
        {{ memberProfile()?.fullName }}
        <div>
          @if (!!age() || !!memberProfile()?.gender) {
            (
            @if (!!age()) {
              <span>{{ age() + " р." }}</span>
            }
            @if (memberProfile()?.gender.toLowerCase() === "male") {
              <span>, {{ "profile.values.gender.male" | translate }}</span>
            } @else if (memberProfile()?.gender.toLowerCase() === "female") {
              <span>, {{ "profile.values.gender.female" | translate }}</span>
            }
            )
          }
        </div>
        <shared-contract-item
          type="status"
          [contract]="lastContract()"
        ></shared-contract-item>
      </div>
    } @else {
      <shared-spin-loading [size]="24"></shared-spin-loading>
    }
  </div>

  <div class="flex w-full flex-col gap-4">
    <div class="flex justify-between gap-2">
      <div class="flex items-center gap-2">
        <h2>{{ "appointments.headings.details" | translate }}</h2>

        @if (detailsFormRef()?.isChanged() && !savingDetails()) {
          <div
            type="button"
            class="flex cursor-pointer items-center gap-2 text-primary-500 hover:text-primary-600"
            (click)="saveDetails()"
          >
            <mat-icon class="font-bold">check_small</mat-icon>
            <span class="underline">{{ "buttons.save" | translate }}</span>
          </div>
          <div
            type="button"
            class="flex cursor-pointer items-center gap-2 text-error-600 hover:text-error-700"
            (click)="cancelChanges()"
          >
            <mat-icon class="font-bold">close_small</mat-icon>
            <span class="underline">{{ "buttons.cancel" | translate }}</span>
          </div>
        }

        @if (detailsSaved() && !detailsFormRef()?.isChanged()) {
          <div class="flex cursor-default items-center gap-2 text-success-600">
            <mat-icon class="font-bold">check_small</mat-icon>
            <span class="underline">{{ "appointments.label.noteSaved" | translate }}</span>
          </div>
        }
      </div>
      <div class="flex gap-6">
        <p class="flex items-center gap-2">
          <span class="text-sm text-neutral-300">{{ "appointments.label.createdAt" | translate }}:</span> {{ planningDetails()?.createdAt | date: "dd.MM.yyyy (HH:mm)" }}
        </p>
      </div>
    </div>

    @if (planningDetails(); as details) {
      <prescriptions-appointment-details-form [planningDetails]="details"></prescriptions-appointment-details-form>
    } @else {
      <div class="flex justify-center py-4">
        <shared-spin-loading [size]="24"></shared-spin-loading>
      </div>
    }
  </div>

  <!-- Parent div in case additional elements are needed -->
  <div class="grid grid-cols-2 gap-4">
    <div class="col-span-1 flex flex-col gap-4">
      <div class="flex items-center gap-2">
        <h2>{{ "appointments.headings.notes" | translate }}</h2>
        @if (notesFormRef()?.isChanged() && !loadingNote()) {
          <div
            type="button"
            class="flex cursor-pointer items-center gap-2 text-primary-500 hover:text-primary-600"
            (click)="saveNote()"
          >
            <mat-icon class="font-bold">check_small</mat-icon>
            <span class="underline">{{ "buttons.save" | translate }}</span>
          </div>
          <div
            type="button"
            class="flex cursor-pointer items-center gap-2 text-error-600 hover:text-error-700"
            (click)="rollbackNoteInForm()"
          >
            <mat-icon class="font-bold">close_small</mat-icon>
            <span class="underline">{{ "buttons.cancel" | translate }}</span>
          </div>
        }

        @if (noteSaved() && !notesFormRef()?.isChanged()) {
          <div class="flex cursor-default items-center gap-2 text-success-600">
            <mat-icon class="font-bold">check_small</mat-icon>
            <span class="underline">{{ "appointments.label.noteSaved" | translate }}</span>
          </div>
        }
      </div>

      <prescriptions-appointment-notes-form
        [originalContent]="appointmentNote()?.content ?? ''"
        [loading]="loadingNote()"
      ></prescriptions-appointment-notes-form>
    </div>
  </div>

  @if (planningDetails()?.appointmentId; as appointmentId) {
    <members-appointment-guarantee
      [memberId]="memberId()"
      [appointmentId]="appointmentId"
    ></members-appointment-guarantee>
  }
</div>
